type Color = "orange" | "lime";
type Position = "tl" | "tr" | "bl" | "br";

interface BlobProps {
  color: Color;
  position: Position;
  size?: number;
}

export function Blob({ color, position, size }: BlobProps) {
  const style = size ? { width: `${size}px`, height: `${size}px` } : undefined;
  return (
    <div className={`blob blob--${color} blob--${position}`} style={style} aria-hidden="true" />
  );
}
